import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import logo from '../img/Уральский Деловой Центр.png';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { SERVICE_ROUTE, RENT_ROUTER, VACANCIES_ROUTE, FORKLIT_ROUTE, SHOP_ROUTE } from "../utils/consts";
import '../css/footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <Container>
                <Row className="py-4">
                    <Col md={4} className="footer-column">
                        <div className="footer-brand">
                            <img src={logo} alt="Уральский Деловой Центр" className="footer-logo" />
                        </div>
                    </Col>
                    <Col md={4} className="footer-column">
                        <h5 className="footer-heading">Навигация</h5>
                        <ul className="footer-links">
                            <li><Link to={SHOP_ROUTE}>Запчасти</Link></li>
                            <li><Link to={SERVICE_ROUTE}>Сервис</Link></li>
                            <li><Link to={RENT_ROUTER}>Аренда</Link></li>
                            <li><Link to={FORKLIT_ROUTE}>Погрузчики</Link></li>
                            <li><Link to={VACANCIES_ROUTE}>Вакансии</Link></li>
                        </ul>
                    </Col>
                    <Col md={4} className="footer-column">
                        <h5 className="footer-heading">Контакты</h5>
                        <ul className="footer-contact">
                            <li>
                                <FaPhone className="footer-icon" />
                                <a href="tel:+79122652545">+7 912 265-25-45</a>
                            </li>
                            <li>
                                <FaEnvelope className="footer-icon" />
                                <a href="mailto:89122652545@mail.ru">89122652545@mail.ru</a>
                            </li>
                            <li>
                                <FaMapMarkerAlt className="footer-icon" />
                                <a href="" rel="noopener noreferrer">
                                    Большой Исток, Ключевая 41
                                </a>
                            </li>
                        </ul>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-center py-3">
                        <p className="footer-text">
                            &copy; {new Date().getFullYear()} Уральский Деловой Центр. Все права защищены.
                        </p>
                        <a style={{fontSize: 14}} href="https://t.me/zbxshe">Создатель сайта</a>
                    </Col>
                </Row>

            </Container>
        </footer>
    );
}

export default Footer;